// extracted by mini-css-extract-plugin
var _1 = "PostSkeleton-module__animateUploadProgressBarWidth--ZTKAJ";
var _2 = "PostSkeleton-module__animatedBackground--LKqlm";
var _3 = "PostSkeleton-module__container--ciRFf";
var _4 = "PostSkeleton-module__line--JUnen";
var _5 = "PostSkeleton-module__title--jOewJ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "line", _5 as "title" }
